@if (appError.hasError()) {
  <div class="app-error-overlay" role="alert">
    <div class="app-error-card">
      <h1 class="app-error-title">Serviço temporariamente indisponível</h1>
      <p class="app-error-message">{{ appError.friendlyMessage() }}</p>
      <p class="app-error-hint">Verifique se o servidor e o banco de dados estão rodando.</p>
      <button type="button" class="app-error-btn" (click)="onRetry()">Tentar novamente</button>
    </div>
  </div>
}
<router-outlet></router-outlet>
